import { frontendURL } from '../../../../helper/URLHelper';

const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/tms-integration'),
      component: SettingsContent,
      props: () => ({
        headerTitle: 'TMS_INTEGRATION_SETTINGS.HEADER',
        icon: 'link',
        showBackButton: false,
        backUrl: '',
      }),
      children: [
        {
          path: '',
          name: 'settings_tms_integration',
          component: Index,
          roles: ['administrator', 'master'],
        },
      ],
    },
  ],
};
